import type { SVGProps } from "react"

/**
 * A message bubble with an arrow rising inside it: a conversation that came
 * from somewhere else rather than one held here.
 *
 * Lucide has no such variant — its `MessageSquareShare` puts the arrow outside
 * the bubble, which reads as sending a conversation on rather than taking one
 * in. Drawn to lucide's own metrics (24 box, stroke 2, round joins) with the
 * arrow filling the same 6x6 interior box `MessageSquarePlus` puts its plus in,
 * so it sits in a row of lucide icons without looking hand-made.
 */
export const MessageSquareArrowUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    <path d="M12 13V7" />
    <path d="m9 10 3-3 3 3" />
  </svg>
)
